import paramTypes from "../constants/paramTypes";

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'i'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

//starts at "0th" position - localhost:5000/test - test is 0th position
export function getRouteParameter(position) {
    let url = window.location.pathname;
    let trimmedUrl = url.substring(1, url.length).split("/").filter(x => x && x.toLowerCase() !== "welcome");

    return position < trimmedUrl.length ? trimmedUrl[position] : "";
}

export function getParameter(param) {
    if (param.type === paramTypes.ROUTE_PARAM) {
        return getRouteParameter(param.key);
    }
    else {
        return getParameterByName(param.key);
    }
}
